import { writable } from 'svelte/store';

function createWidgetStore() {
  const { subscribe, set, update } = writable({
    isLoaded: false,
    isVisible: false,
    instance: null,
  });

  return {
    subscribe,
    set,
    update,
    show: () => update(s => ({ ...s, isVisible: true })),
    hide: () => update(s => ({ ...s, isVisible: false })),
    setInstance: (instance: any) => update(s => ({ ...s, instance })),
    setLoaded: (isLoaded: boolean) => update(s => ({ ...s, isLoaded })),
  };
}

export const freshworksWidgetStore = createWidgetStore();
